import styled from 'styled-components'

export const Item = styled.div`
  h2 {
    font-family: Montserrat;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.21px;
    margin-bottom: 0;
  }

  h3 {
    color: #55616b;
    font-family: Lato;
    text-transform: capitalize;
    font-weight: 500;
  }

  span {
    word-break: break-word;
    strong {
      font-size: 14px;
    }
  }
`

export const Capitalized = styled.span`
  text-transform: capitalize;
`

export const DetailsContainer = styled.div`
  margin-top: 20px;
`

export const SectionHeading = styled.h4`
  margin-top: 30px;
`

export const NoData = styled.span`
  font-weight: 700;
  font-size: 14px;
`

export const ActionButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 120px 160px;
  grid-column-gap: 20px;
  justify-items: end;
  align-items: center;
`
